<template>
  <div role="tablist" class="tabs tabs-border bg-base-100 mb-2">
    <RouterLink
      v-for="s in sections"
      :key="s.key"
      role="tab"
      :class="
        twMerge('tab', $route.name === s.route_name && 'tab-active')
      "
      :to="{ name: s.route_name }"
    >
      <span class="flex items-baseline gap-1 pe-1">
        <i :class="twMerge(s.ico, 'opacity-80')"></i>
        <span class="truncate">{{ s.value }}</span>
      </span>
    </RouterLink>
  </div>
  <RouterView />
</template>
<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { RouterLink, RouterView } from "vue-router";

// ponytail: extensible — add a section here and it appears in the nav.
// x86/x64 later = add entries with be_mapping (used by the version filter).
const sections = [
  {
    key: "list",
    value: "Phiên bản",
    ico: "fa-solid fa-folder-open",
    route_name: "VersionList",
  },
  {
    key: "recon",
    value: "Thu thập thông tin",
    ico: "fa-solid fa-magnifying-glass",
    route_name: "VersionRecon",
  },
  {
    key: "base_build",
    value: "Base build",
    ico: "fa-solid fa-box",
    route_name: "VersionBaseBuild",
  },
];
</script>
